import React, {useCallback, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {apiRequest} from "../api";

const EventList = ({tourId, tourName, onEdit, refreshKey}) => {
    const [events, setEvents] = useState([]);
    const [error, setError] = useState(null);
    const [feedbackMessage, setFeedbackMessage] = useState(null);
    const [loading, setLoading] = useState(true);
    const [deletingEventId, setDeletingEventId] = useState(null);

    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem("token");

    // Fetch events (memoized to avoid recreation on every render)
    const fetchEvents = useCallback(async () => {
        if (!tourId) return;

        setLoading(true);
        try {
            const endpoint = `${apiUrl}/event/${tourId}`;
            const data = await apiRequest(endpoint, "GET", null, token);
            setEvents(data);
            setError(null);
        } catch (error) {
            console.error("Error fetching events:", error);
            setError("Failed to load events. Please try again.");
        } finally {
            setLoading(false);
        }
    }, [apiUrl, tourId, token]);

    // Fetch events when tourId or refreshKey changes
    useEffect(() => {
        fetchEvents();
    }, [fetchEvents, refreshKey]);

    const handleDelete = async (eventId) => {
        setDeletingEventId(eventId);
        try {
            const url = `${apiUrl}/events/${eventId}`;
            const response = await fetch(url, {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (!response.ok) {
                throw new Error("Failed to delete event.");
            }
            setFeedbackMessage("Event deleted successfully.");
            fetchEvents(); // Refresh events after deletion
        } catch (error) {
            console.error("Error deleting event:", error);
            setFeedbackMessage("Failed to delete event. Please try again.");
        } finally {
            setDeletingEventId(null);
        }
    };

    if (loading) {
        return <p>Loading events...</p>;
    }

    return (
        <div className="tours">
            {feedbackMessage && <p className="text-success">{feedbackMessage}</p>}
            {error && <p className="text-danger">{error}</p>}
            <table>
                <thead>
                <tr>
                    <th>EVENT NAME</th>
                    <th>UNIVERSITY NAME</th>
                    <th>EVENT DATE</th>
                    <th>CREATED DATE</th>
                    <th>CREATED BY</th>
                    <th>LAST UPDATED</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                {events.length > 0 ? (
                    events.map((event) => (
                        <tr key={event.id}>
                            <td>{event.name}</td>
                            <td>{event.university.name}</td>
                            <td>
                                {event.event_date
                                    ? new Date(event.event_date + "T00:00:00").toLocaleDateString("en-US")
                                    : "No Date"}
                            </td>
                            <td>
                                {event.created_on
                                    ? new Date(event.created_on).toLocaleDateString("en-US")
                                    : "No Date"}
                            </td>
                            <td>{event.created_by}</td>
                            <td>
                                {event.last_updated
                                    ? new Date(event.last_updated).toLocaleDateString("en-US")
                                    : "No Date"}
                            </td>
                            <td>

                                &nbsp;
                                <button
                                    className="btn btn-sm btn-danger"
                                    onClick={() => handleDelete(event.id)}
                                    disabled={deletingEventId === event.id}
                                >
                                    {deletingEventId === event.id ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                            Deleting...
                                        </>
                                    ) : (
                                        'Delete'
                                    )}
                                </button>
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="7" className="text-center">No events available for this tour.</td>
                    </tr>
                )}
                </tbody>
            </table>
        </div>
    );
};

export default EventList;